/**
 * Determines if a menu item's URL matches the current browser location.
 *
 * @param {string} itemUrl - The resolved item URL (with dynamic params replaced).
 * @param {string} pathname - The current browser pathname.
 * @param {string} search - The current browser search/query string (e.g. "?site=1&dashboard=abc").
 * @returns {boolean}
 */
export function doesItemUrlMatch(itemUrl, pathname, search) {
  if (!itemUrl) return false;

  const itemPath = itemUrl.split("?")[0];
  const itemQuery = itemUrl.split("?")[1] || "";

  if (!itemPath) return false;

  const pathMatches =
    pathname === itemPath || pathname.endsWith("/" + itemPath);

  if (!pathMatches) return false;

  // When item URL has query params, verify they all match current URL params
  if (itemQuery) {
    const itemParams = new URLSearchParams(itemQuery);
    const currentParams = new URLSearchParams(search);
    for (const [key, value] of itemParams.entries()) {
      if (currentParams.get(key) !== value) {
        return false;
      }
    }
  }

  return true;
}

/**
 * Determines if a menu item should be considered "selected" based on Redux state.
 *
 * @param {string[]} selectedItem - Array of selected item IDs from Redux store.
 * @param {string} itemId - The current item's ID.
 * @param {string} parentId - The parent menu group ID.
 * @param {string} pathname - The current browser pathname.
 * @returns {boolean}
 */
export function isItemSelected(selectedItem, itemId, parentId, pathname) {
  if (!selectedItem) return false;

  const currentIndex = selectedItem.findIndex((id) => id === itemId);
  if (currentIndex === -1) return false;

  if (parentId === "dashboards" || parentId === "reports") {
    const parentIndex = pathname
      .toString()
      .split("/")
      .findIndex((id) => id === parentId);
    return parentIndex > -1;
  }

  return true;
}
